export default __webpack_public_path__ + "static/media/cross_cancel.e4226c05.jpg";